// Package Imports
import React from 'react';
import { DatePicker, Form } from 'antd';

// Project Imports
import { DateInputProps } from 'components/date/type';
// import ConfigStyle from 'core/constants/ConfigStyle';

const DateInput = ({
  label,
  name,
  style,
  disabled,
  required,
  message,
  placeholder,
  format,
  getValueProps,
  showTime,
  use12Hours,
  picker = 'date',
  showWeek = false,
  value,
}: DateInputProps) => (
  <div
    className={
      disabled
        ? 'floating-disabled relative custom-border'
        : 'relative custom-border'
    }
  >
    {label ? (
      <label className="floating-label">
        {label} {required ? <span className="a8-error">*</span> : null}
      </label>
    ) : null}
    <Form.Item
      rules={[{ required, message }]}
      style={style}
      name={[name]}
      getValueProps={getValueProps}
      hasFeedback={required || !!value}
    >
      <DatePicker
        className="py-3"
        disabled={disabled}
        placeholder={placeholder}
        format={format}
        showTime={showTime}
        use12Hours={use12Hours}
        picker={picker}
        showWeek={showWeek}
      />
    </Form.Item>
  </div>
);

export default DateInput;
